import { classNames } from 'primereact/utils';
import { FC } from 'react';
import { EditClusterDateButton } from './EditClusterDateButton';

interface GroupLabelProps {
  text: string;
  level: number;
  /** When set, a pencil appears on hover to edit this label's cluster date. */
  onEditDate?: () => void;
}

export const GroupLabel: FC<GroupLabelProps> = ({ text, level, onEditDate }) => {
  const label = (
    <div
      lang="en"
      className={classNames('bg-fletchers-white text-[12px]/[16px]', 'truncate', {
        // Sized to its text next to a pencil so the icon sits against the date;
        // min-w-0 (without flex-1) lets a long name truncate rather than grow.
        'min-w-0': !!onEditDate,
        'w-full': !onEditDate,
        'font-[400]': level === 1 || level === 3,
        'font-[500]': level === 2,
        'font-[300]': level === 4,
      })}
      title={text}
    >
      {text}
    </div>
  );

  if (!onEditDate) return label;

  // The pencil sits inside the hover group so hovering anywhere on the date
  // reveals it, not just the icon itself.
  return (
    <div className="group/date-label flex w-full min-w-0 items-center gap-1">
      {label}
      <EditClusterDateButton onClick={onEditDate} />
    </div>
  );
};
